import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useT } from '../i18n';

const LoginPage = () => {
  const t = useT();
  const { oktaAuth } = useOktaAuth();

  useEffect(() => {
    oktaAuth.signInWithRedirect({ originalUri: '/' });
  }, [oktaAuth]);

  return (
    <>
      <div className="App">
        <header className="App-header">
          {t('x.redirectingOkta')}
        </header>
      </div>
    </>
  );
};

export default LoginPage;
